<template>
  <div v-if="!isLoadingInit" class="guest-block">
    <b-row class="justify-content-between my-5">
      <!-- Label -->
      <b-col cols="12" sm="6">
        <label>Nom complet</label>
        <ValidationProvider
          ref="vee-guest-fullname"
          v-slot="{ errors, classes }"
          :name="'Nom complet'"
          rules="required"
        >
          <b-input v-model="meeting_guest.fullname" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col cols="12" sm="6">
        <label>Email</label>
        <ValidationProvider
          ref="vee-guest-email"
          v-slot="{ errors, classes }"
          :name="'Email'"
          rules="required|email"
        >
          <b-input v-model="meeting_guest.email" />
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col v-if="meeting_guest.username" cols="12" sm="6">
        <label>Nom d'utilisateur</label>
        <b-input v-model="meeting_guest.username" disabled />
      </b-col>
      <b-col v-if="meeting_guest.password" cols="12" sm="6">
        <label>Mot de passe</label>
        <b-input v-model="meeting_guest.password" disabled />
      </b-col>
    </b-row>
    <b-row class="justify-content-between my-4">
      <b-col cols="auto">
        <b-button :disabled="isLoadingSave" class="button btn-red" @click="cancel">
          <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="times-circle" />
          <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
          <span>{{ $t("general.cancel") }}</span>
        </b-button>
      </b-col>

      <b-col cols="auto">
        <b-button :disabled="isLoadingSave" class="button btn-blue" @click="CREATE_GUEST">
          <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="plus" />
          <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
          <span>{{ $t("general.create") }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
  <appLoader v-else />
</template>

<script>
import links from "@/links/links";
import { validate } from "vee-validate";

import MeetingGuestMW from "@/middlewares/MeetingGuest";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

import MediaMW from "@/middlewares/Media";
import { fileURLToPath } from "url";
import { meetingGuestAccessStatuses } from "@/constants/meeting-guest.js";

var path = require("path");
var uniqid = require("uniqid");

export default {
  props: ["meetingId"],
  data() {
    return {
      isLoadingInit: false,
      isLoadingSave: false,
      meeting_guest: {
        fullname: "",
        email: "",
        meeting_id: this.meetingId,
        agency_id: Number(localStorage.getItem("agencyId")),
      },
      // NOTE: Files
      links: links,
      meetingGuestAccessStatuses,
    };
  },
  computed: {},
  async created() {},
  methods: {
    async validateInputs() {
      var valid = true;
      await validate(this.meeting_guest.fullname, "required", {}).then(res => {
        if (!res.valid) {
          valid = false;
          this.$refs["vee-guest-fullname"].validate();
        }
      });
      await validate(this.meeting_guest.email, "required|email", {}).then(res => {
        if (!res.valid) {
          valid = false;
          this.$refs["vee-guest-email"].validate();
        }
      });
      return valid;
    },
    cancel() {
      this.$emit("cancel");
    },
    async CREATE_GUEST() {
      if ((await this.validateInputs()) == false) {
        return;
      }
      await MeetingGuestMW.REGISTER(this.meeting_guest)
        .then(res => {
          this.meeting_guest.username = res.username;
          this.meeting_guest.password = res.password;
          this.meeting_guest.user_id = parseInt(res.userId);
          this.meeting_guest.access_status = this.meetingGuestAccessStatuses.allow;
        })
        .catch(err => {
          console.error(err);
        });
      await MeetingGuestMW.POST(this.meeting_guest).then(res => {
        console.log("res");
        this.$swal({
          text: "Invité ajouté avec succès",
          title: "Succès",
          icon: "success",
          timer: 2500,
          showConfirmButton: false,
        });
      });

      this.cancel();
    },
  },
};
</script>
